 window.addEventListener("scroll", function() {
    let scrollY = window.scrollY;
    // let vhQuarter = window.innerHeight / 4;
    // let logo = document.getElementById("logo");
    let header = document.querySelector(".header-sticker");
    
    // if (scrollY >= vhQuarter) {
    //     logo.style.transform = "translateY(10px) rotate(15deg)";
    // } else {
    //     logo.style.transform = "translateY(0) rotate(0)";
    // }

    if (!header) { return; } // pages without a sticky header
    if (scrollY >= 100) {
        header.classList.add("active");
    } else {
        header.classList.remove("active");
    }
});

// Vanilla JS (no jQuery dependency): keeps the product button price in whole dollars.
(function () {
    function fetchVariantPrice(variantId) {
      if (!variantId) { return; } // no variant selector on this page (avoids /variants/undefined.js 404)
      fetch('/variants/' + variantId + '.js')
        .then(function (response) { return response.ok ? response.json() : null; })
        .then(function (data) {
          if (!data) { return; }
          var price = data.price / 100;
          document.querySelectorAll('.button_price').forEach(function (el) {
            el.textContent = '$' + Math.round(price); // display only: whole dollars
          });
        })
        .catch(function () {});
    }

    function init() {
      var inputs = document.querySelectorAll('.section-product-main .variant-id');
      inputs.forEach(function (input) {
        input.addEventListener('change', function () {
          fetchVariantPrice(this.value);
        });
      });
      fetchVariantPrice(inputs.length ? inputs[0].value : undefined);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
})();
